var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import logger from '@redbubble/next-logger';
var AmplitudeExperiments = /** @class */ (function () {
    function AmplitudeExperiments(localEvaluationClient) {
        this.localEvaluationClient = localEvaluationClient;
    }
    AmplitudeExperiments.prototype.evaluate = function (federatedId, additionalProperties) {
        var variants = this.localEvaluationClient.evaluateV2(__assign(__assign({}, additionalProperties), { user_id: federatedId }));
        return Object.fromEntries(Object.entries(variants)
            // We only use experiments with amplitude and so we filter out all non experiment variants
            // This allows us to build an object of just experiments and not worry about passing undefined
            // to the props which will throw an error
            .filter(function (_a) {
            var _b;
            var variant = _a[1];
            return ((_b = variant.metadata) === null || _b === void 0 ? void 0 : _b.flagType) === 'experiment';
        })
            // build out a simpler object relative to the data we require
            // variantData.key is used istead of variantData.value as the latter is used
            // for feature flags only and for passing data to be used in the application
            // for example a feature flag could be Variant key: "on",  value: "Get Started"
            // we never want to use feature flags as webproxy provides an existing solution
            // that is not reliant on an external resource
            .map(function (_a) {
            var _b;
            var variantName = _a[0], variantData = _a[1];
            return [
                variantName,
                {
                    enrolment: (_b = variantData.key) !== null && _b !== void 0 ? _b : 'off',
                },
            ];
        }));
    };
    return AmplitudeExperiments;
}());
export { AmplitudeExperiments };
var AmplitudeExperimentsContext = /** @class */ (function () {
    function AmplitudeExperimentsContext(initial) {
        this.current = initial;
    }
    AmplitudeExperimentsContext.prototype.swap = function (client) {
        this.current = client;
    };
    AmplitudeExperimentsContext.prototype.evaluate = function (federatedId, additionalProperties) {
        return this.current.evaluate(federatedId, additionalProperties);
    };
    return AmplitudeExperimentsContext;
}());
export { AmplitudeExperimentsContext };
var FailedAmplitudeExperiments = /** @class */ (function () {
    function FailedAmplitudeExperiments() {
    }
    FailedAmplitudeExperiments.prototype.evaluate = function () {
        var message = 'Amplitude client failed to start, returning empty experiments';
        logger.error({
            err: { error: message },
            context: 'AmplitudeExperiments/evaluate',
            message: message,
        }, message);
        return {};
    };
    return FailedAmplitudeExperiments;
}());
export { FailedAmplitudeExperiments };
